import { render, staticRenderFns } from "./xcoinRules.vue?vue&type=template&id=09dfe8ee&scoped=true&"
import script from "./xcoinRules.vue?vue&type=script&lang=js&"
export * from "./xcoinRules.vue?vue&type=script&lang=js&"
import style0 from "./xcoinRules.vue?vue&type=style&index=0&id=09dfe8ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dfe8ee",
  null
  
)

export default component.exports